import React from 'react'
import styles from './DropdownMenu.scss'
import TooltipTrigger from 'react-popper-tooltip'

export const DropdownMenu = ({ children, content, tooltipShown: tooltipShownProps, ...props }) => {
  const [tooltipShown, setTooltipVisibility] = React.useState(tooltipShownProps || true)
  // const [tooltipProps, setTooltipProps] = React.useState<any>(props)

  const renderDropdown = ({ tooltipRef, getTooltipProps }) => (
    <div
      className={styles.DropdownMenu}
      {...getTooltipProps({
        ref: tooltipRef,
        onClick: () => handleDropdownClick(),
      })}>
      <div className={styles.DropdownMenuWrapper}>{content}</div>
    </div>
  )

  // const currentProps = { ...tooltipProps, ...{ tooltipShown: true } }

  const handleDropdownClick = () => {
    setTimeout(() => {
      setTooltipVisibility(false)
    }, 10)
  }

  const handleDropdownVisibility = visible => {
    setTooltipVisibility(visible)
  }

  React.useEffect(
    () => {
      setTooltipVisibility(tooltipShownProps)
    },
    [tooltipShownProps],
  )

  return (
    <TooltipTrigger
      {...props}
      tooltipShown={tooltipShown}
      tooltip={renderDropdown}
      onVisibilityChange={handleDropdownVisibility}>
      {({ getTriggerProps, triggerRef }) =>
        React.cloneElement(children, {
          ...getTriggerProps({
            ref: triggerRef,
          }),
        })
      }
    </TooltipTrigger>
  )
}



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DropdownMenu.js